import { createFileRoute } from "@tanstack/react-router"
import { LiveEventSettings } from "@/features/live-events-admin/config/LiveEventSettings"

export const Route = createFileRoute("/live-events/$eventId/settings")({
	component: SettingsPage,
})

function SettingsPage() {
	const { eventId } = Route.useParams()
	return <LiveEventSettings eventId={eventId} />
}
